import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getExtraInformation = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const { displayPage } = data;
        const response = await api('get', 'extra-information', { displayPage });
        const docs = response.data?.docs;
        return docs && docs.length > 0 ? docs[0] : null;
    });
